import React from 'react'
import {withRouter} from "react-router-dom"
import {Card, Select, TimePicker} from "antd"
import {ClubCleanTableRecordProvider} from "./store/useClubCleanTableRecordContext"
import ClubCleanTableRecordLayout from "./layout"

const ClubCleanTableRecord = () => {
    return <div>
        <ClubCleanTableRecordProvider>
            <ClubCleanTableRecordLayout></ClubCleanTableRecordLayout>
        </ClubCleanTableRecordProvider>
    </div>
}

export default withRouter(ClubCleanTableRecord)


// WEBPACK FOOTER //
// ./src/containers/ClubCleanTableRecord/index.js